import React from "react"
import Typography from "aldoo-ra/Typography"
import { showPromptDialog } from "aldoo-ra/PromptDialog"
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline"

/**
 * Reusable Primary Pack Confirmation Dialog
 * Shows confirmation dialog when setting a pack as primary
 */
export const showPrimaryPackConfirmDialog = (onConfirm) => {
  showPromptDialog({
    title: "Set Pack as Primary",
    message: (
      <div className="space-y-4">
        <Typography variant="admin_body" className="text-admin_text">
          Are you sure you want to set this pack as primary?
        </Typography>
        
        <div className="bg-admin_warning/10 border border-admin_warning/20 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <ExclamationTriangleIcon className="w-6 h-6 text-admin_warning flex-shrink-0 mt-0.5" />
            <div>
              <Typography variant="admin_body" className="text-admin_warning font-medium mb-2">
                Important Notice
              </Typography>
              <Typography variant="admin_txt1" className="text-admin_text_secondary">
                When users buy products from the store, all autogenerated licenses will be put into this pack.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    ),
    confirmText: "Set as Primary",
    cancelText: "Cancel",
    onConfirm,
  })
}

export default showPrimaryPackConfirmDialog